import { Drawer } from "//luxusbetten24.de/cdn/shop/t/209/assets/theme.js?v=160545541957230751071745521878";

var FavoritesDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return true;
  }

  get openFrom() {
    return window.matchMedia(
        `${ window.themeVariables.breakpoints['sm-max'] }`).matches
        ? this.getAttribute('mobile-open-from') || 'top'
        : this.getAttribute('open-from') || 'right';
  }
};

if (!window.customElements.get('favorites-drawer')) {
  window.customElements.define('favorites-drawer', FavoritesDrawer);
}

// document.addEventListener('alpine:init', () => {
//   Alpine.data('maisonFavorites', () => ({
//     products: [],
//     selectedProducts: [],
//     init() {
//       this.$watch('$store.favorites.favorites', () => {
//         this.loadProducts();
//       });
//
//       document.getElementById('favorites-drawer').addEventListener('dialog:after-show', () => {
//         this.loadProducts();
//       });
//     },
//     formatCurrency(value) {
//       const f = new Intl.NumberFormat(Shopify.locale, {
//         style: 'currency',
//         currency: Shopify.currency.active
//       });
//
//       return f.format(value);
//     },
//     getProductMinPrice(product) {
//       return Math.min(...product.variants.map(v => v.price));
//     },
//     async loadProducts() {
//       if (this.products.length === 0) {
//         // TODO: Change to storefront logic ...
//         let response = await fetch('/products.json?limit=250').then((response) => response.json());
//         this.products = response.products;
//       }
//
//       this.selectedProducts = this.products.filter(
//           product => this.$store.favorites.isProductFavorite(product.id));
//     },
//   }));
// });